<template> 
  <div class="app">
    <Header/>
    
    <section class="hbox stretch"> 
      <Sidebar/>
      <section class="content">
            <router-view/>
          </section>
       
    </section> 
  </div>
</template>

<script>
import Header from '@/components/layout/Header.vue'
import Sidebar from '@/components/layout/Sidebar.vue'

export default {
  name: 'Layout',
  components: {
    Header,
    Sidebar
  }
}
</script>